import Textarea from "@mui/joy/Textarea";
import {
  Box,
  Button,
  Chip,
  FormControl,
  MenuItem,
  OutlinedInput,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import React, { useState, useEffect, useRef } from "react";
import { FaUpload } from "react-icons/fa";
import { getDetailCourseById, updateCourse, uploadMedia } from "../service";
import { ListItemDataUpdate } from "../interface";
import dayjs from "dayjs";
import { getCookie } from "utils/setCookie";
import tiers from "../service/tiers.json";

const EditCourse = ({
  getDetailCourse,
  handleCloseEdit,
  style,
  updateDetailCourse,
  setSnackbarOpen,
  setSnackbarMessage,
  setSnackbarSeverity,
  fetchData,
}) => {
  const imageInputRef = useRef<HTMLInputElement>(null);
  const videoInputRef = useRef<HTMLInputElement>(null);

  const [formData, setFormData] = useState<ListItemDataUpdate>({
    _id: "",
    price_id: "",
    price: "",
    title: "",
    avatar: "",
    country: "country",
    version: "version",
    end_time: "",
    language: "en",
    media_id: "",
    product_id: "product_id",
    start_time: "",
    description: "",
    trash_status: "trash_status",
    public_status: "public_status",
    long_description: "",
    product_status: "",
    labels: "",
    level: "",
    skills: [],
    type: "Call 1-1",
    coupon_id: null,
  });
  const [avatarUrl, setAvatarUrl] = useState<string | null>(
    getDetailCourse?.avatar?.media_url || null
  );
  const [videoUrl, setVideoUrl] = useState<string | null>(
    getDetailCourse?.media_id?.media_url || null
  );
  const [inputValue, setInputValue] = useState("");
  const [items, setItems] = useState([]);
  const handleFileChangeAndUpload = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    try {
      const files = event.target.files;
      if (files && files.length > 0) {
        const file = files[0];

        const headers = {
          "X-Authorization": getCookie("session"),
        };

        const uploadedFiles = await uploadMedia(file, headers);
        console.log("Uploaded files:", uploadedFiles);

        if (uploadedFiles.length > 0) {
          const { id, src } = uploadedFiles[0];

          setFormData((prevData) => ({
            ...prevData,
            avatar: id,
          }));
          setAvatarUrl(src);
        }
      }
    } catch (error) {
      console.error("Upload failed:", error);
    } finally {
      console.log("Upload completed");
    }
  };

  const handleFileChangeAndUploadVideo = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    try {
      const files = event.target.files;
      if (files && files.length > 0) {
        const file = files[0];

        const headers = {
          "X-Authorization": getCookie("session"),
        };

        const uploadedFiles = await uploadMedia(file, headers);

        if (uploadedFiles.length > 0) {
          const { id, src } = uploadedFiles[0];

          setFormData((prevData) => ({
            ...prevData,
            media_id: id,
          }));
          setVideoUrl(src);
        }
      }
    } catch (error) {
      console.error("Upload failed:", error);
    } finally {
      console.log("Upload completed");
    }
  };

  const handleButtonClick = () => {
    imageInputRef.current.click();
  };

  const handleButtonClickVideo = () => {
    videoInputRef.current.click();
  };
  console.log('fasfasfasf', getDetailCourse)
  useEffect(() => {
    if (getDetailCourse) {
      setFormData({
        ...formData,
        _id: getDetailCourse?._id,
        price_id: getDetailCourse?.price_id || formData?.price_id,
        price: getDetailCourse?.price?.toString(),
        title: getDetailCourse?.title,
        avatar: getDetailCourse?.avatar?._id,
        media_id: getDetailCourse?.media_id?._id,
        country: getDetailCourse?.country,
        version: getDetailCourse?.version,
        end_time: getDetailCourse?.end_time,
        language: getDetailCourse?.language,
        product_id: getDetailCourse?.product_id,
        start_time: getDetailCourse?.start_time,
        description: getDetailCourse?.description,
        trash_status: getDetailCourse?.trash_status,
        public_status: getDetailCourse?.public_status,
        long_description: getDetailCourse?.long_description,
        product_status: getDetailCourse?.product_status,
        labels: getDetailCourse?.labels,
        level: getDetailCourse?.level,
        skills: getDetailCourse?.skills,
        type: getDetailCourse?.type,
        coupon_id: null,
      });
    }
  }, [getDetailCourse]);

  const handleSave = async () => {
    try {
      await updateCourse(
        formData?._id,
        formData?.price_id,
        String(formData.price),
        formData.title,
        formData.avatar,
        formData.media_id,
        formData.country,
        formData.version,
        formData.end_time,
        formData.language,
        formData.product_id,
        formData.start_time,
        formData.description,
        formData.trash_status,
        formData.public_status,
        formData.long_description,
        formData.product_status,
        formData.labels,
        formData.level,
        formData.skills,
        formData.type,
        formData.coupon_id
      );
      const response = await getDetailCourseById(formData._id);
      await fetchData();
      updateDetailCourse(response.data);
      setSnackbarMessage("Chỉnh sửa thành công");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
    } catch (error) {
      setSnackbarMessage("Chỉnh sửa thất bại");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };

  const handleChangeCourse = (field, value) => {
    if (field === "price") {
      const selectedTier = tiers.find((tier) => tier.value === value);
      setFormData((prevData) => ({
        ...prevData,
        price: value, 
        price_id: selectedTier ? selectedTier.id : prevData.price_id, 
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [field]: value,
      }));
    }
  };
  

  // const handleInputChange = (event) => {
  //     setInputValue(event.target.value);
  // };

  // const handleKeyPress = (event) => {
  //     if (event.key === 'Enter' && inputValue.trim() !== '') {
  //         setItems([...items, inputValue]);
  //         setInputValue('');
  //     }
  // };

  // const handleDelete = (index) => {
  //     const newItems = items.filter((_, i) => i !== index);
  //     setItems(newItems);
  // };
  const skillsOptions = ["Listening", "Reading", "Writing", "Speaking"];
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: 224,
        width: 250,
      },
    },
  };

  const handleChangeSkills = (event) => {
    const {
      target: { value },
    } = event;
    setFormData({
      ...formData,
      skills: typeof value === "string" ? value.split(",") : value,
    });
  };

  return (
    <Box sx={style}>
      <Typography variant="h6" mb={2} fontWeight={550}>
        Chỉnh sửa Khóa học
      </Typography>
      <Stack
        direction="row"
        gap={2}
        alignItems="center"
        justifyContent="space-between"
      >
        <Box sx={{ width: "450px" }}>
          <TextField
            value={formData?._id}
            onChange={(e) => handleChangeCourse("id", e.target.value)}
            name="title"
            fullWidth
            placeholder="Điền tiêu đề"
            size="small"
            sx={{ mb: 1, display: "none" }}
          />

          <Stack direction="column" gap={1}>
            <Typography variant="body1" fontWeight={550}>
              Tiêu đề:{" "}
            </Typography>
            <TextField
              value={formData.title}
              onChange={(e) => handleChangeCourse("title", e.target.value)}
              name="title"
              fullWidth
              placeholder="Điền tiêu đề"
              size="small"
              sx={{ mb: 1 }}
            />
          </Stack>
          <Stack direction="column" gap={1} mb={2}>
            <Typography variant="body1" fontWeight={550}>
              Thời gian học:
            </Typography>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <Stack
                direction="row"
                alignItems="center"
                gap={2}
                justifyContent="space-between"
              >
                <input
                  type="date"
                  name="start_time"
                  value={
                    formData.start_time
                      ? new Date(formData.start_time)
                          .toISOString()
                          .split("T")[0]
                      : ""
                  }
                  onChange={(e) =>
                    handleChangeCourse("start_time", e.target.value)
                  }
                  placeholder="Chọn ngày bắt đầu"
                  style={{
                    width: "100%",
                    padding: "10px",
                    borderRadius: "5px",
                    border: "1px solid #ccc",
                  }}
                />
                <input
                  type="date"
                  name="end_time"
                  value={
                    formData.end_time
                      ? new Date(formData.end_time).toISOString().split("T")[0]
                      : ""
                  }
                  onChange={(e) =>
                    handleChangeCourse("end_time", e.target.value)
                  }
                  placeholder="Chọn ngày kết thúc"
                  style={{
                    width: "100%",
                    padding: "10px",
                    borderRadius: "5px",
                    border: "1px solid #ccc",
                  }}
                />
              </Stack>
            </LocalizationProvider>
          </Stack>

          <Stack direction="column" gap={1}>
            <Typography variant="body1" fontWeight={550}>
              Mô tả:
            </Typography>
            <Textarea
              color="neutral"
              value={formData.description}
              onChange={(e) =>
                handleChangeCourse("description", e.target.value)
              }
              name="description"
              minRows={3}
              placeholder="Mô tả"
              sx={{ mb: 2 }}
            />
          </Stack>

          <Stack direction="column" gap={1}>
            <Typography variant="body1" fontWeight={550}>
              Chi tiết khóa học:
            </Typography>
            <Textarea
              color="neutral"
              value={formData.long_description}
              onChange={(e) =>
                handleChangeCourse("long_description", e.target.value)
              }
              name="long_description"
              minRows={5}
              placeholder="Chi tiết khóa học"
              sx={{ mb: 2 }}
            />
          </Stack>

          {/* <Stack direction='column' gap={1} mb={2}>
                    <Typography variant='body1' fontWeight={550}>Thời gian học:</Typography>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <Stack direction="row" alignItems="center" gap={2} justifyContent="space-between">
                            <DatePicker 
                                className='datePicker' 
                                onChange={(date) => handleChangeCourse("start_time", date)}
                                name="start_time"
                                slotProps={{ textField: { placeholder: 'Chọn ngày bắt đầu' } }}
                                sx={{ width: '100%' }}/>
                            <DatePicker 
                                className='datePicker' 
                                onChange={(date) => handleChangeCourse("end_time", date)}
                                name="end_time"
                                slotProps={{ textField: { placeholder: 'Chọn ngày kết thúc' } }}
                                sx={{ width: '100%' }}/>
                        </Stack>
                    </LocalizationProvider>
                </Stack> */}

          <Box
            display="flex"
            flexDirection="row"
            alignItems="center"
            gap={2}
            mb={2}
          >
            <Box flex={1}>
              <Typography variant="body1" fontWeight={550} mb={1}>
                Kiểu khóa học:
              </Typography>
              <FormControl fullWidth>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={formData.type} // Use formData.type as the value
                  onChange={(e) => handleChangeCourse("type", e.target.value)}
                  name="type"
                  fullWidth
                  size="small"
                >
                  <MenuItem value="Self-learning">Self-learning</MenuItem>
                  <MenuItem value="Call 1-1">Call 1 - 1</MenuItem>
                  <MenuItem value="Call group">Call group</MenuItem>
                </Select>
              </FormControl>
            </Box>
          </Box>
          <Box
            display="flex"
            gap={1}
            flexDirection="row"
            alignItems="center"
            sx={{ mb: 2 }}
          >
            <Box flex={1}>
              <Typography variant="body1" fontWeight={550} mb={1}>
                Kiểu khóa học:
              </Typography>
              <FormControl fullWidth>
                <Select
                  labelId="course-type-select-label"
                  id="course-type-select"
                  value={formData.type}
                  onChange={(e) => handleChangeCourse("type", e.target.value)}
                  name="type"
                  fullWidth
                  size="small"
                >
                  <MenuItem value="Self-learning">Self-learning</MenuItem>
                  <MenuItem value="Call 1-1">Call 1 - 1</MenuItem>
                  <MenuItem value="Call group">Call group</MenuItem>
                </Select>
              </FormControl>
            </Box>

            <Box flex={1}>
              <Typography variant="body1" fontWeight={550} mb={1}>
                Giá khóa học (VNĐ):
              </Typography>

              {formData.type === "Call 1-1" ? (
                <TextField
                  fullWidth
                  value={formData.price}
                  onChange={(e) => handleChangeCourse("price", e.target.value)}
                  name="price"
                  placeholder="Nhập giá khóa học"
                  size="small"
                />
              ) : (
                <FormControl fullWidth>
                  <Select
                    labelId="course-price-select-label"
                    id="course-price-select"
                    value={formData.price}
                    onChange={(e) =>
                      handleChangeCourse("price", e.target.value)
                    }
                    name="price"
                    fullWidth
                    size="small"
                  >
                    {tiers.map((tier) => (
                      <MenuItem key={tier.id} value={tier.value}>
                        {tier.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )}
            </Box>

            {/* <Box flex={1} gap={2}>
              <Typography variant="body1" fontWeight={550} mb={1}>
                Giá khóa học(coin):
              </Typography>
              <TextField
                fullWidth
                value={formData.coin_price}
                onChange={(e) =>
                  handleChangeCourse("coin_price", e.target.value)
                }
                name="coin"
                placeholder="Giá khóa học"
                size="small"
              />
            </Box> */}
          </Box>
          <Box sx={{ mb: 2 }} flex={1}>
            <Typography variant="body1" fontWeight={550} mb={1}>
              Kĩ năng:
            </Typography>
            <FormControl fullWidth>
              <Select
                id="demo-multiple-chip"
                multiple
                value={formData.skills}
                onChange={handleChangeSkills}
                input={<OutlinedInput />}
                renderValue={(selected) => (
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                    {Array.isArray(selected) ? (
                      selected.map((value) => (
                        <Chip key={value} label={value} />
                      ))
                    ) : (
                      <Chip key={selected} label={selected} />
                    )}
                  </Box>
                )}
                MenuProps={MenuProps}
                size="small"
              >
                {skillsOptions.map((skill) => (
                  <MenuItem key={skill} value={skill}>
                    {skill}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
          <Box sx={{ mb: 2 }} flex={1}>
            <Typography variant="body1" fontWeight={550} mb={1}>
              Cấp độ:
            </Typography>
            <FormControl fullWidth>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={formData.level}
                onChange={(e) => handleChangeCourse("level", e.target.value)}
                name="level"
                fullWidth
                size="small"
              >
                <MenuItem value="band_0_2">0 - 2.0+ IELTS</MenuItem>
                <MenuItem value="band_2_4">2.0 - 4.0+ IELTS</MenuItem>
                <MenuItem value="band_4_5">4.0 - 5.0+ IELTS</MenuItem>
                <MenuItem value="band_5_6">5.0 - 6.0+ IELTS</MenuItem>
                <MenuItem value="band_6_7">6.0 - 7.0+ IELTS</MenuItem>
                <MenuItem value="band_7_5">7.5+ IELTS</MenuItem>
              </Select>
            </FormControl>
          </Box>
          {/* <Stack direction='column' gap={1} >
                        <Typography variant='body1' fontWeight={550}>Nhan:</Typography>
                        <TextField
                            placeholder='Nhap nhan dan'
                            variant="outlined"
                            value={inputValue}
                            onChange={handleInputChange}
                            onKeyPress={handleKeyPress}
                            fullWidth
                        />
                        <List>
                            {items.map((item, index) => (
                                <ListItem sx={{ background: '#e9e9e9', borderRadius: '30px' }} key={index} secondaryAction={
                                    <IconButton edge="end" aria-label="delete" onClick={() => handleDelete(index)}>
                                        <MdDelete />
                                    </IconButton>
                                }>
                                    <ListItemText primary={item} />
                                </ListItem>
                            ))}
                        </List>
                    </Stack> */}
        </Box>
        <Box sx={{ width: "250px" }}>
          <Box>
            <Typography variant="body1" fontWeight={550} mb={1}>
              Hình ảnh giới thiệu khóa học:
            </Typography>
            <Box>
              {/* {mediaType === 'image' && <img src={mediaSrc} alt="Media preview" width={250} />}
                // {mediaType === 'video' && <video src={mediaSrc} controls width={250}></video>} */}
              {avatarUrl && (
                <img
                  src={avatarUrl}
                  alt="banner"
                  style={{ width: "250px", cursor: "pointer" }}
                  onClick={handleButtonClick}
                />
              )}
              {!avatarUrl && getDetailCourse?.avatar?.media_url && (
                <img
                  src={getDetailCourse.avatar.media_url}
                  alt="banner"
                  style={{ width: "250px", cursor: "pointer" }}
                  onClick={handleButtonClick}
                />
              )}
            </Box>
            <input
              id="file-input"
              type="file"
              accept="image/*"
              style={{ display: "none" }}
              ref={imageInputRef}
              onChange={handleFileChangeAndUpload}
            />
            <Button
              variant="contained"
              startIcon={<FaUpload />}
              sx={{
                width: "250px",
                height: "180px",
                background: "transparent",
                color: "#333",
                fontWeight: 550,
                border: "1px dashed",
                marginBottom: 2,
                display: "none",
              }}
            >
              Tải ảnh/video
            </Button>
          </Box>
          <Box>
            <Typography variant="body1" fontWeight={550} mb={1}>
              Video giới thiệu khóa học:
            </Typography>
            <Box>
              {/* {mediaType === 'image' && <img src={mediaSrc} alt="Media preview" width={250} />}
                // {mediaType === 'video' && <video src={mediaSrc} controls width={250}></video>} */}
              {videoUrl && (
                <video
                  src={videoUrl}
                  style={{ width: "250px", cursor: "pointer" }}
                  onClick={handleButtonClickVideo}
                />
              )}
              {!videoUrl && getDetailCourse?.media_id?.media_url && (
                <video
                  src={getDetailCourse?.media_id?.media_url}
                  style={{ width: "250px", cursor: "pointer" }}
                  onClick={handleButtonClickVideo}
                />
              )}
            </Box>
            <input
              id="file-input"
              type="file"
              accept="video/*"
              style={{ display: "none" }}
              ref={videoInputRef}
              onChange={handleFileChangeAndUploadVideo}
            />
            <Button
              variant="contained"
              startIcon={<FaUpload />}
              sx={{
                width: "250px",
                height: "180px",
                background: "transparent",
                color: "#333",
                fontWeight: 550,
                border: "1px dashed",
                marginBottom: 2,
                display: "none",
              }}
            >
              Tải ảnh/video
            </Button>
          </Box>
        </Box>
      </Stack>
      <Stack direction="row" gap={2} justifyContent="space-between" mt={2}>
        <Button fullWidth onClick={handleCloseEdit} size="small">
          Thoát
        </Button>
        <Button
          fullWidth
          size="small"
          variant="contained"
          onClick={handleSave}
          sx={{
            bgcolor: "#B32519 !important",
            "&:hover": { bgcolor: "#B32519 !important" },
          }}
        >
          Cập nhật
        </Button>
      </Stack>
    </Box>
  );
};

export default EditCourse;
